import _extends from '@babel/runtime-corejs3/helpers/extends';
import React__default, { forwardRef } from 'react';
import classNames from 'classnames';
import styles from './Icon.js';

const IconSizes = {
  small: 16,
  medium: 24,
  large: 32
};
const createIconComponent = (type, svgContent) => {
  const Icon = /*#__PURE__*/forwardRef((_ref, ref) => {
    let {
      size = 'medium',
      className,
      'aria-hidden': ariaHidden,
      ...rest
    } = _ref;
    const classes = classNames(styles.icon, className);
    const pixels = IconSizes[size];
    return /*#__PURE__*/React__default.createElement("svg", _extends({}, rest, {
      className: classes,
      ref: ref,
      width: pixels,
      height: pixels,
      focusable: "false",
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      "data-icontype": type,
      "aria-hidden": ariaHidden,
      dangerouslySetInnerHTML: {
        __html: svgContent
      } // eslint-disable-line react/no-danger
    }));
  });
  Icon.displayName = "".concat(type, "Icon");
  return Icon;
};

export { createIconComponent as default };
